module.exports = __webpack_public_path__ + "635596d7e4ef5ffa62b0c95727d17e5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 826
// module chunks = 0